// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___y-Q6","label":"styles_label__MLxk2"};